import { styled } from '@mui/material';

export const styles = {
  fonts: {
    main: { color: 'primary.main', textTransform: 'capitalize' },
    text: { color: 'text.primary', textTransform: 'capitalize' },
  },
  backButton: {
    icon: {
      width: '18px',
      height: '18px',
    },
    sx: {
      textAlign: 'center',
      color: 'text.secondary',
    },
  },
};

export const Item = styled('div')(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.grey[500],
  fontSize: '20px',
  fontWeight: 700,
}));
